import { render, staticRenderFns } from "./Supply.vue?vue&type=template&id=19fcc4db"
import script from "./Supply.vue?vue&type=script&lang=js"
export * from "./Supply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports